import { GetStaticProps } from 'next';

import { withEventScope } from '@repo/event-processor';

import LandingPage from 'components/Landing/LandingPage/LandingPage';
import { getLibraryPageStaticProps } from 'global/libraryPageUtils';

export const getStaticProps: GetStaticProps = async (context) => {
  return await getLibraryPageStaticProps(context, 'education');
};

export default withEventScope(LandingPage, { page: 'educationLanding' });
